import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { KeyDropLocationViewModel } from '../business-entities/dealer-keydrop-location-view-model';
import { KeyDropLocationDataService } from '../data-services/dealer-keydrop-location-data.service';
import { SelectListItemViewModel } from '../business-entities/select-list-item-view-model';

@Injectable({
    providedIn: 'root'
})

export class KeyDropLocationService {
    KeydropLocationId : number;
    dealerId: string;
    isEdit: boolean = false;
    dealerList: Array<SelectListItemViewModel>;
    constructor(private service: KeyDropLocationDataService) {
    }

    async getKeyDropLocation(dealerId :string) : Promise<GenericResponse<Array<KeyDropLocationViewModel>>> {
       return  this.service.getKeyDropLocation(dealerId);
    }

    async addKeyDropLocation(model: KeyDropLocationViewModel): Promise<GenericResponse<KeyDropLocationViewModel>> {
        return  this.service.addKeyDropLocation(model);
    }

    async getKeyDropLocationById(id: number):Promise<GenericResponse<KeyDropLocationViewModel>> {
        return  this.service.getKeyDropLocationById(id);
    }

    async updateKeyDropLocation(model: KeyDropLocationViewModel): Promise<GenericResponse<KeyDropLocationViewModel>> {
        return  this.service.updateKeyDropLocation(model);
    }

    async deleteKeyDropLocation(Id: number) :Promise<GenericResponse<boolean>> {
        return  this.service.deleteKeyDropLocation(Id);
    }

    async getLocationList() : Promise<GenericResponse<Array<SelectListItemViewModel>>> {
        return  this.service.getLocationList()
     }
}
